var $ = window.jQuery;
mobile = window.innerWidth < 460 ? true : false;
console.log(siteSettings);
console.log(pageSettings.page_type);
console.log($(window).scrollTop());
console.log('legals build');


googletag.pubads().addEventListener('slotRenderEnded', function(event) {
    if (event.slot === googletag.slots["med_rec_1"] && !event.isEmpty) {
        console.log('med_rec_1 ad');
        window.med_rec_1 = 1;
    } else if (event.slot === googletag.slots["med_rec_1"] && event.isEmpty) {
        console.log('no med_rec_1 ad');
        window.med_rec_1 = 0;
        var newsletterHTML = '<h4 class="border_section">Email Alerts</h4><div class="widget__form-subscribe bg__card-shadow"><h6>Register for Public Notice Email Alerts</h6><a href="https://floridapublicnotices.com/" target="_blank" class="signup-button-link" style="display: inline-block; text-align:center; width:100%; padding: 10px 20px; background-color: #205DA9; color: white; text-decoration: none; border-radius: 5px;">Click to Sign Up</a></div>';
        $('#atf_cta').html(newsletterHTML);
    }
    console.log('hello world');
});